/**
 * The Tabbio spark that heads an activity trace on web — the exact vector
 * from the recruiter interface's `spark-solid.svg`, drawn inline so it takes
 * `currentColor` and dims from "working" to "settled" with a colour
 * transition. Native draws the same path in `agent-sparkle-icon.tsx`.
 */
import type { CSSProperties, FC } from 'react';
import { TABBIO_SPARK_PATH, TABBIO_SPARK_VIEWBOX } from './tabbio-spark-path';

export const AgentSparkleIcon: FC<{ size?: number; className?: string; style?: CSSProperties }> = ({
  size = 16,
  className,
  style,
}) => (
  <svg
    width={size}
    height={size}
    viewBox={TABBIO_SPARK_VIEWBOX}
    fill="currentColor"
    aria-hidden
    className={className}
    style={style}
  >
    <path d={TABBIO_SPARK_PATH} />
  </svg>
);
